import React from "react";
import Select from "react-select";
import makeAnimated from "react-select/animated";

const animatedComponents = makeAnimated();

export const AssignTraining = ({
  assignData,
  isLoadingSelect,
  handleChange,
  disable,
}) => {
  const options = assignData?.map((value) => ({
    value: value.id,
    label: value.departmentName,
  }));

  return (
    <Select
      closeMenuOnSelect={false}
      components={animatedComponents}
      isMulti
      isLoading={isLoadingSelect}
      onChange={handleChange}
      options={options}
      isDisabled={disable}
      className={`focus:!border-black focus:!border-2 focus:!border-t-0 ${
        disable ? "pointer-events-none" : ""
      }`}
    />
  );
};

export const AssignEmpolyeeWise = ({
  assignData,
  isLoadingSelect,
  handleChange,
  disable,
}) => {
  const employedPeople = assignData?.filter(
    (employee) => employee.employeeStatus !== "resigned"
  );
  
  return (
    <Select
      closeMenuOnSelect={false}
      components={animatedComponents}
      isMulti
      isLoading={isLoadingSelect}
      onChange={handleChange}
      options={employedPeople}
      isDisabled={disable}
      getOptionLabel={(option) => option?.employeeName}
      getOptionValue={(option) => option?.id}
      className={`focus:!border-black focus:!border-2 focus:!border-t-0 ${
        disable ? "pointer-events-none" : ""
      }`}
    />
  );
};
